module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p4"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "chaptertitle chapter"
  }, [_vm._v("Silencer to the Heart "), _c('br'), _vm._v("While Jogging Through a Park")]), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("I shouldn’t have to go here")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("with you: a bandit ties the farmer’s dog to a century")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("oak by the untouched creek. You see human")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("interest piece, sunny & rounding out the evening news")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("where I see eclipsed casket. Where I say released he will roam")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("the same radius. Surely, I don’t have to tell you there’s a gun")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("semi-automatic & lodged in the black cherry thicket, but I do")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("have to tell you about the semi-automatic jail cell clanging")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("open, not for me, because that’s just sound world-making.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("I’ll say it like this: I don’t jog in the park with my blindsides")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("shaded anymore. Look, here, through the spangled screen")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("door: there was once a kid, ordinary in every American leisure")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("except one. I won’t name him. You’ll look away.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Again: there was too much Shepherd’s Pie, a slice of Apple")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("& one sturdy carving knife. In damp air hung glints")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("of siren moon, few sirens, sleepy porch lamps blinking on")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("& an ache for antacids that jogged a man")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("to the corner store, like puttering wind, then back over")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("the town’s little blacktop hills near the park’s edge")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("where there was a shot streetlight & lots of wheezing")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("over a bench, & there were three shadows, a pit bull")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("tied to the bench & a bulge in his gut")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("that was a bulge in his gut, which")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("must’ve looked to one shadow like a box cutter & not")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("a roll of Tums, & then there are, frankly,")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("too many black cherry thickets streaked with blood.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("Sometimes, I can barely walk")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("out into daylight wearing a cotton sweatshirt")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "follow"
  }, [_vm._v("without trembling. & surely I don’t have to")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("tell you who gets put down, which one walks away.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1c59d42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c01.vue
// module id = 72
// module chunks = 0